import React from 'react'
import './../App.css'
import './../style/about.css'
import Pagetitle from '../components/pagetitle/Pagetitle'
import aboutimg1 from './../Images/about-img5-0e67ec1feeea62d1003e3a4869f464d6.png'
import rotateicon from './../Images/download.png'
import circleimg from './../Images/circle-shape1-84499f1a9f5baf6107753940a219d149.png'
export default function Aboutus() {
  return (
    <div>
      <Pagetitle pagename="About Us" parentpage="Home" />
      <section className="about_section-1 ptb-100">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <img src={aboutimg1} />
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="about-content">
                <div className='sub-title'><img src={rotateicon} /> ABOUT IHUNAR</div>
                <h1>Excellent IT services for your success</h1>
                <p>We Are Increasing Business Success With Technology. Over 1 year working in IT services developing software applications, websites and mobile apps for clients all over the World.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="circle_img_main">
          <img src={circleimg}/>
        </div>
        <div className="container">
          <div>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6 justify-content-start">
                <div>
                  <h3>Our Mission</h3>
                  <p>To cater to every Software need, Swiftly and Effectively</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div>
                  <h3>Our Vision</h3>
                  <p>To be the best software solution provider in the world, helping change the world of Technology through our top-notch Software Engineering Solutions.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
